import React from "react";
import Line from "../../../assets/line2.svg";

const data = [
  {
    feature: "Deliverability",
    superVerified: "98%+ guaranteed",
    partiallyVerified: "70%+ estimate",
  },
  {
    feature: "Cost",
    superVerified: "Charged per contact",
    partiallyVerified: "Free",
  },
  {
    feature: "Best For",
    superVerified: "High-impact campaigns",
    partiallyVerified: "Broader outreach efforts",
  },
  {
    feature: "Data Included",
    superVerified: "Email, corporate phone, social links",
    partiallyVerified: "Email",
  },
];

const Table = () => {
  return (
    <>
      <div className="text-center w-full mt-12">
        <h2 className="text-3xl sm:text-4xl  lg:text-[3rem] lg:leading-[3.5rem] font-bold">
          Let's{" "}
          <span className="relative inline-block">
            Compare
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
            />
          </span>{" "}
          Emails
          {/* section */}
        </h2>
      </div>
      <div className="flex flex-col items-center justify-center px-10 pt-16 pb-28">
        <div className="w-full overflow-x-auto max-w-4xl rounded-lg shadow-lg">
          <table className="min-w-full bg-white border border-gray-200 rounded-lg">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Feature
                </th>
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Super Verified
                </th>
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Partially Verified
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index} className="border-b border-gray-200">
                  <td className="px-6 py-4 text-gray-700">{row.feature}</td>
                  <td className="px-6 py-4 text-gray-700">
                    {row.superVerified}
                  </td>
                  <td className="px-6 py-4 text-gray-700">
                    {row.partiallyVerified}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Table;
